/**
 * Tax utility functions for consistent handling across quote components
 * Based on schema: amountPresalesTax and amountPostsalesTax are NOT NULL for quotes
 */

export interface QuoteTaxData {
  amountPresalesTax: number; // NOT NULL in schema
  amountPostsalesTax: number; // NOT NULL in schema for quotes
  taxAmount?: number | null; // Can be null
}

/**
 * Safely get tax amount, returning 0 if null/undefined
 */
export function getTaxAmount(taxAmount: number | null | undefined): number {
  return taxAmount ?? 0;
}

/**
 * Check if tax should be displayed (has meaningful tax amount)
 */
export function shouldDisplayTax(
  taxAmount: number | null | undefined,
): boolean {
  return getTaxAmount(taxAmount) > 0;
}
